import React, { useState } from 'react';
import { publications } from '../../data/portfolio';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionHeader from '../SectionHeader/SectionHeader';
import { FiExternalLink, FiFileText, FiBookOpen, FiX } from 'react-icons/fi';
import './Publications.css';

function Publications() {
  const [activeId, setActiveId] = useState(null);
  const activePub = publications.find((p) => p.id === activeId);
  const [rowRef, rowVisible] = useScrollReveal(0.1);

  return (
    <section className="publications section" id="publications">
      <div className="container">
        <SectionHeader title="Publications" subtitle="Research papers & academic work" />

        <div ref={rowRef} className={`pub-row reveal--stagger ${rowVisible ? 'reveal--visible' : ''}`}>
          {publications.map((pub, i) => (
            <div
              className={`pub-tile ${activeId === pub.id ? 'pub-tile--active' : ''}`}
              key={pub.id}
              onClick={() => setActiveId(activeId === pub.id ? null : pub.id)}
            >
              <div className="pub-tile__glow" />

              <span className="pub-tile__num">{String(i + 1).padStart(2, '0')}</span>

              <div className="pub-tile__icon">
                <FiBookOpen />
              </div>

              <h3 className="pub-tile__title">{pub.title}</h3>

              <div className="pub-tile__meta">
                <span className="pub-tile__year">{pub.year}</span>
                <span className="pub-tile__venue">{pub.venue.split('(')[0].trim()}</span>
              </div>

              <div className="pub-tile__tags">
                {pub.tags.slice(0, 2).map((t) => (
                  <span key={t} className="pub-tile__tag">{t}</span>
                ))}
              </div>

              <div className="pub-tile__actions">
                {pub.doi && (
                  <a
                    href={pub.doi}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pub-tile__paper-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FiExternalLink /> View Paper
                  </a>
                )}
                <span className="pub-tile__cta">Read more</span>
              </div>
            </div>
          ))}
        </div>

        {activePub && (
          <div className="pub-detail" onClick={() => setActiveId(null)}>
            <div className="pub-detail__card" onClick={(e) => e.stopPropagation()}>
              <div className="pub-detail__top-bar">
                <span className="pub-detail__year">{activePub.year}</span>
                <button className="pub-detail__close" onClick={() => setActiveId(null)}>
                  <FiX />
                </button>
              </div>

              <h3 className="pub-detail__title">{activePub.title}</h3>

              <p className="pub-detail__authors">
                {activePub.authors.map((author, i) => (
                  <span key={i}>
                    <span className={author === 'Viraj Yadav' ? 'pub-detail__author--me' : ''}>
                      {author}
                    </span>
                    {i < activePub.authors.length - 1 && ', '}
                  </span>
                ))}
              </p>

              <p className="pub-detail__venue">{activePub.venue}</p>

              <p className="pub-detail__abstract">{activePub.abstract}</p>

              <div className="pub-detail__tags">
                {activePub.tags.map((t) => (
                  <span key={t} className="pub-detail__tag">{t}</span>
                ))}
              </div>

              <div className="pub-detail__footer">
                {activePub.doi && (
                  <a href={activePub.doi} target="_blank" rel="noopener noreferrer" className="pub-detail__link">
                    <FiExternalLink /> View Paper
                  </a>
                )}
                {activePub.pdf && (
                  <a href={activePub.pdf} target="_blank" rel="noopener noreferrer" className="pub-detail__link">
                    <FiFileText /> PDF
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Publications;
